import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.21.8_@parcel+watcher@2.5.6_@types+node@24.10.0_@vue+compiler-sfc@3.5.38_cac@6.7.14_db0_wpkfhih34jfokj32gd6nf7vbge/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/app/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}